import type { HttpClient } from '../client';
import type { Id } from '@hq/utils';

export interface AiChatRequest {
  question: string;
  orgId?: Id;
}

export interface AiChatAnswer {
  id: Id;
  question: string;
  /** BUDGET / ALERT / STOCK / APPLY / DELIVERY / HELP。 */
  intent: string;
  answer: string;
  /** 结构化取数结果（前端可渲染卡片）。 */
  data: unknown;
  /** 结论引用的业务单号。 */
  traceBizNos: string[];
  costMs: number;
  /** 是否由外部大模型生成（false = 本地规则引擎）。 */
  llmUsed: boolean;
  model: string | null;
  /** 大模型未就绪/失败时的提示，不视为错误。 */
  notice: string | null;
}

export interface AiChatHistoryRow {
  id: Id;
  question: string;
  intent: string;
  answer: string;
  traceBizNos: string | null;
  feedback: string | null;
  costMs: number;
  createAt: string;
}

/**
 * AI 问答：后端先用规则引擎取真实数据，大模型就绪时再润色成自然语言。
 * 配置项 `Hq:Ai:*` 为「待补充…」时仍返回规则答案（`llmUsed=false` + `notice`）。
 */
export function createAiChatApi(http: HttpClient) {
  return {
    chat(body: AiChatRequest): Promise<AiChatAnswer> {
      return http.request<AiChatAnswer>({ path: '/wl/ai/chat', method: 'POST', body });
    },

    history(size = 20): Promise<AiChatHistoryRow[]> {
      return http.request<AiChatHistoryRow[]>({ path: '/wl/ai/chat', query: { size: String(size) } });
    },

    feedback(id: Id, feedback: 'GOOD' | 'BAD'): Promise<{ id: Id; feedback: string }> {
      return http.request<{ id: Id; feedback: string }>({
        path: `/wl/ai/chat/${id}/feedback`,
        method: 'POST',
        body: { feedback }
      });
    }
  };
}

export type AiChatApi = ReturnType<typeof createAiChatApi>;
